<template>
  <div
    class="product-search-v1 w-full max-w-md flex flex-col"
    ref="websiteSearchApp">
    <div class="w-full relative flex items-center">
      <input
        type="text"
        name="Smart search"
        class="w-full h-10 rounded-full bg-white border-none outline-none pl-5 pr-32 text-gray italic font-medium leading-normal"
        placeholder="Smart search"
        v-model="state.searchValue"
        @keyup.enter="searchRequestHandler" />
      <div
        class="w-28 h-8 rounded-full absolute right-1 top-1 flex items-center justify-center cursor-pointer bg-red hover:bg-red-dark tr-all"
        @click="searchRequestHandler">
        <img
          src="/images/icons/icon-search-white.svg"
          alt="Icon search white"
          width="16"
          height="20"
          class="block w-4 h-auto mr-2" />
        <span class="font-medium text-white">Search</span>
      </div>
    </div>
    <div
      v-if="state.isSearchValueErrorVisible"
      class="w-full text-sm text-red">
      Please enter a minimum of {{ VariablesHelper.SEARCH_INPUT_MIN_LENGTH }} characters.
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue';
import GlobalPreloaderHelper from '@/helpers/global/globalPreloader.helper';
import VariablesHelper from '@/helpers/global/variables.helper';

const websiteSearchApp = ref(null);

const state = reactive({
  selectedCompanyUid: '',
  searchValue: '',
  isSearchValueErrorVisible: false,
  searchUrl: '/search',
});

const searchByCompanyItemsClickHandler = () => {
  const searchByCompanyItems = document.querySelectorAll('.search-by-company-item');
  if (searchByCompanyItems.length > 0) {
    searchByCompanyItems.forEach((item) => {
      item.addEventListener('click', () => {
        const clickedCompanyUid = item.getAttribute('data-company-uid');
        
        // If clicking the same company, deselect it
        if (state.selectedCompanyUid === clickedCompanyUid) {
          state.selectedCompanyUid = '';
          
          // Remove styling from all items
          searchByCompanyItems.forEach((i) => {
            i.classList.remove('!text-red', 'font-medium');
          });
          
          // If there's a search value, trigger search without company filter
          if (state.searchValue.length >= VariablesHelper.SEARCH_INPUT_MIN_LENGTH) {
            searchRequestHandler();
          }
        } else {
          // Select the clicked company
          state.selectedCompanyUid = clickedCompanyUid;

          if (state.searchValue.length >= VariablesHelper.SEARCH_INPUT_MIN_LENGTH) {
            searchRequestHandler();
          } else {
            searchByCompanyItems.forEach((i) => {
              i.classList.remove('!text-red', 'font-medium');
            });
            item.classList.add('!text-red', 'font-medium');
          }
        }
      });
    });
  }
};

const searchRequestHandler = () => {
  if (state.searchValue.length >= VariablesHelper.SEARCH_INPUT_MIN_LENGTH) {
    GlobalPreloaderHelper.show();

    state.isSearchValueErrorVisible = false;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = state.searchUrl;
    const csrfField = document.createElement('input');
    csrfField.type = 'hidden';
    csrfField.name = 'csrfmiddlewaretoken';
    csrfField.value = CSRF_TOKEN;
    form.appendChild(csrfField);

    const queryField = document.createElement('input');
    queryField.type = 'hidden';
    queryField.name = 'q';
    queryField.value = `${state.searchValue.replace(' ', '+')}`;
    form.appendChild(queryField);

    if (state.selectedCompanyUid.length > 0) {
      const companyField = document.createElement('input');
      companyField.type = 'hidden';
      companyField.name = 'company';
      companyField.value = state.selectedCompanyUid;
      form.appendChild(companyField);
    }
    document.body.appendChild(form);
    history.replaceState(null, '', window.location.href);
    form.submit();
  } else {
    state.isSearchValueErrorVisible = true;
  }
};

onMounted(() => {
  state.searchUrl = `${window.location.href.split('search')[0]}search`;

  if (websiteSearchApp.value !== null) {
    const dataAttrSearchUrl = websiteSearchApp.value.parentElement.getAttribute('data-search-url');
    if (dataAttrSearchUrl !== null && dataAttrSearchUrl.length > 0) {
      state.searchUrl = dataAttrSearchUrl;
    }

    const dataAttrSearchQ = websiteSearchApp.value.parentElement.getAttribute('data-search-q');
    if (dataAttrSearchQ !== null && dataAttrSearchQ.length > 0) {
      state.searchValue = decodeURIComponent(dataAttrSearchQ.replace(/\+/g, ' '));
    }

    const dataAttrSearchCompanyUid = websiteSearchApp.value.parentElement.getAttribute('data-search-company-uid');
    if (dataAttrSearchCompanyUid !== null && dataAttrSearchCompanyUid.length > 0) {
      state.selectedCompanyUid = dataAttrSearchCompanyUid;
    }
  }

  searchByCompanyItemsClickHandler();
});
</script>
